import {Product} from "@app/core/product/domain/dtos/product";

interface ListParams {
    id: number;
    code: number
    name: string;
    image: string | null;
    products: Product[];
    totalPrice: number;
}

export class List {
    id: number;
    // The code is the real identifier of the list.
    code: number
    name: string;
    image: string | null;
    products: Product[];
    totalPrice: number;
    isFavoriteList: boolean;

    constructor(params: ListParams) {
        this.id = params.id;
        this.code =  params.code;
        this.name = params.name;
        this.image = params.image;
        this.products = params.products;
        this.totalPrice = params.totalPrice;
        // This is the only way to identify a favorite list.
        this.isFavoriteList = this.id === -1;
    }
}